/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- NAV : STYLES --------------- ++++++++++ */
export default {
	activatemigration: {
    display: 'flex',
    flexDirection: 'column',
    gap: pxToEm(16),
    '& path': {
      fill: '#000'
    },
    '& .button': {
      color: theme.color.primary.medium.contrast,
      background: theme.color.primary.medium.swatch,
      '& .loader > div': {
        borderColor: `#FFFFFF transparent transparent transparent`
      }
    }
  }
}; 